export default __webpack_public_path__ + "static/media/tailwind-css-seeklogo.com.a29695b3.svg";